//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@vue/store';
export default {
  props: {
    entryTitle: {
      type: String,
      default: '記事タイトル'
    },
    entryDate: null,
    basename: null
  },
  mounted: function mounted() {
    this.setTableClass();
  },
  computed: {
    setDate: function setDate() {
      return store.getters['app/setDate'];
    },
    setTableClass: function setTableClass() {
      return store.getters['app/setTableClass'];
    },
    categories: function categories() {
      try {
        return window.$mt_data.categories;
      } catch (error) {
        return [];
      }
    }
  },
  methods: {
    backPage: function backPage() {
      window.history.back();
    }
  }
};